import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";
import { Payload } from "../types";
import { IoCheckmarkCircle } from "react-icons/io5";

const GetIntouch = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);

	useEffect(() => {
		if (isSuccess) {
			setTimeout(() => {
				setIsSuccess(false);
			}, 3000);
		}
	}, [isSuccess]);
	const { register, handleSubmit, reset } = useForm<Payload>();
	const onSubmit = (data: Payload) => {
		setIsLoading(true);
		fetch("https://kimbohlovette.onrender.com/api/v1/mails/send", {
			headers: {
				"Content-Type": "application/json",
			},
			method: "post",
			body: JSON.stringify(data),
		})
			.then((data) => {
				setIsSuccess(true);
				reset();
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};
	return (
		<section className="w-full px-4 sm:px-12 md:px-16 max-w-7xl mx-auto">
			<div className="w-full flex flex-col md:flex-row gap-8">
				<div className="flex-1 [&>*]:flex-1 w-full flex flex-col gap-y-5 text-slate-200">
					<div className="flex flex-wrap items-center gap-x-4 md:block">
						<h2 className="font-semibold text-xl text-primary pb-2">
							Write me a mail:
						</h2>
						<p className="font-light text-primary">
							kimbohlovette@gmail.com
						</p>
					</div>
					<div className="flex flex-wrap items-center gap-x-4 md:block">
						<h2 className="font-medium text-lg text-primary pb-2">
							Call me:
						</h2>
						<p className="font-light text-slate-600">
							+237 654-115-922
						</p>
					</div>
					<div className="flex flex-wrap items-center gap-x-4 md:block">
						<h2 className="font-medium text-lg text-primary pb-2">
							Knock on my door:
						</h2>
						<p className="font-light text-slate-600">
							{" "}
							Buea, Molyko
						</p>
					</div>
					<div className="flex items-center gap-x-4 md:block">
						<h2 className="font-medium text-lg text-primary pb-2">
							Let's go social:
						</h2>
						<div className="flex flex-row justify-center md:justify-start gap-x-2 mt-5 [&>*]:max-w-fit text-slate-200">
							<div className="h-10 aspect-square rounded-full bg-primary flex items-center justify-center hover:bg-blue-950 hover:scale-105 transition-transform duration-100 ease-linear cursor-pointer">
								<a
									href="https://www.github.com/kimbohlovette"
									target="_blank"
									rel="noreferrer"
								>
									<Tooltip title="Github" arrow>
										<Icon icon="mdi:github" />
									</Tooltip>
								</a>
							</div>
							<div className="h-10 aspect-square rounded-full bg-primary flex items-center justify-center hover:bg-blue-950 hover:scale-105 transition-transform duration-100 ease-linear cursor-pointer">
								<a
									href="https://www.linkedin.com/in/kimbohlovette"
									target="_blank"
									rel="noreferrer"
								>
									<Tooltip title="Linkedin" arrow>
										<Icon icon="ps:linkedin" />
									</Tooltip>
								</a>
							</div>
							<div className="h-10 aspect-square rounded-full bg-primary flex items-center justify-center hover:bg-blue-950 hover:scale-105 transition-transform duration-100 ease-linear cursor-pointer">
								<a
									href="https://www.twitter.com/kimbohlovette"
									target="_blank"
									rel="noreferrer"
								>
									<Tooltip title="Twitter" arrow>
										<Icon icon="mdi:twitter" />
									</Tooltip>
								</a>
							</div>
						</div>
					</div>
				</div>
				<form
					onSubmit={handleSubmit(onSubmit)}
					className="flex-1 flex flex-col gap-4 bg-white py-8 px-4 sm:py-12 md:p-16 shadow-lg rounded-lg font-medium"
				>
					<div className="w-full">
						<label
							htmlFor="name"
							className="relative block text-primary max-w-fit"
						>
							Full Name
						</label>
						<input
							type="text"
							{...register("name")}
							name="name"
							disabled={isLoading}
							required
							placeholder="John Doe"
							className="py-3 px-4 focus:outline-blue-400 rounded-md min-w-0 w-full focus:bg-slate-50 bg-slate-100 text-slate-500 font-light"
						/>
					</div>
					<div className="w-full">
						<label
							htmlFor="email"
							className="relative block text-primary max-w-fit"
						>
							Email
						</label>
						<input
							type="email"
							{...register("email")}
							required
							disabled={isLoading}
							placeholder="john-doe@someone.com"
							className="py-3 px-4 focus:outline-blue-400 rounded-md min-w-0 w-full focus:bg-slate-50 bg-slate-100 text-slate-500 font-light"
						/>
					</div>

					<div className="w-full">
						<label
							htmlFor="message"
							className="relative block text-primary max-w-fit"
						>
							Message
						</label>
						<textarea
							required
							{...register("message")}
							name="message"
							disabled={isLoading}
							placeholder="Compose message..."
							className="py-3 px-4 focus:outline-blue-400 rounded-md min-w-0 w-full focus:border-blue-400 focus:bg-slate-50 bg-slate-100 text-slate-500 font-light"
						/>
					</div>
					<div className="mt-5">
						<button className="text-slate-100 py-2 px-4 rounded-md bg-primary hover:bg-blue-950 flex items-center gap-2 float-right border-2 border-transparent focus:border-primary focus:outline-none">
							{!isSuccess ? (
								<Icon
									icon={
										isLoading
											? "eos-icons:three-dots-loading"
											: "quill:send"
									}
								/>
							) : (
								<IoCheckmarkCircle />
							)}
							Send message
						</button>
					</div>
				</form>
			</div>
		</section>
	);
};

export default GetIntouch;
